import api from '@/api/project';
import pmApi from '@/api/projectMember';
import popup from '@/model/popup';
import push from '@/model/push';
import store from '@/store';
import router from '@/router';

export default {
  // eslint-disable-next-line
  getEllipsisMenu({ access, project, onArchiveStateChanged, onRemoved, onProjectLeft }) {
    const items = [];

    if (access.canEditProject()) {
      items.push({
        text: 'Редактировать',
        icon: 'edit',
        route: { name: 'project-edit', params: { projectId: project.id } },
      });
    }

    if (access.canCopyProject()) {
      items.push({
        text: 'Копировать',
        icon: 'edit',
        handler: () => { this.duplicate(project); },
      });
    }

    if (access.canCreateReferralSample()) {
      items.push({
        text: 'Создать авторский проект',
        icon: 'edit',
        handler: () => { this.createReferralSample(project); },
      });
    }

    if (!project.isArchived && access.canArchiveProject()) {
      items.push({
        text: 'В архив',
        icon: 'archive',
        handler: () => { this.archive(project, true, onArchiveStateChanged); },
      });
    }

    if (project.isArchived && access.canUnarchiveProject()) {
      items.push({
        text: 'Восстановить',
        icon: 'archive',
        handler: () => { this.archive(project, false, onArchiveStateChanged); },
      });
      items.push({
        text: 'Удалить',
        icon: 'trash',
        handler: () => { this.remove(project, onRemoved); },
      });
    }

    if (access.isProjectMember()) {
      items.push({
        text: 'Покинуть проект',
        icon: 'close3',
        handler: () => { this.leave(project, onProjectLeft); },
      });
    }

    return items;
  },

  async createReferralSample(project) {
    const desc = 'Авторский проект – это шаблон проекта, которым вы делитесь со своими рефералами. При этом не будут доступны участники проекта, комментарии и история событий. Обратите внимание – при создании авторского проекта будет создана копия проекта, из которой участники, комментарии и история будут удалены. Всё остальное, включая файлы, задачи и чек-листы, станет доступным для всех ваших рефералов (пользователей, которые зарегистрировали по вашей рефереальной ссылке). Они смогут скопировать себе данный проект и использовать его в качестве шаблона.';
    if (!await popup.addConfirm('Создать авторский проект?', desc)) return;

    api.duplicate(project.id, { isReferralSample: true }, true)
      .then(r => {
        router.push({ name: 'project-stages', params: { projectId: r.id } });
        push.add({ text: 'Авторский проект создан' });
      });
  },
  async duplicate(project) {
    const desc = project.isReferralSample
      ? 'Будут скопированы все задачи (названия, описания, чек-листы), блоки задач, описание проекта.'
      : 'Будут скопированы все задачи (названия, описания, чек-листы), блоки задач, описание проекта. ~~ Сроки проекта и задач будут сдвинуты. Комментарии в задачах, файлы и участники {не будут скопированы}.';
    if (!await popup.addConfirm('Создать копию проекта?', desc)) return;

    api.duplicate(project.id)
      .then(r => {
        router.push({ name: 'project-stages', params: { projectId: r.id } });
        push.add({ text: 'Копия проекта создана' });
      });
  },
  async archive(project, isArchive, onArchiveStateChanged) {
    if (isArchive && project.numberOfTasks > project.numberOfClosedTasks) {
      const res = await popup.addConfirm('В проекте есть открытые задачи. Вы уверены, что хотите отправить проект в архив? Работа в проекте будет невозможна.');

      if (!res) return;
    }

    api.archive(project.id, isArchive, true).then(onArchiveStateChanged);
  },
  async remove(project, onRemoved) {
    if (await popup.addConfirm(`Вы действительно хотите удалить проект [${project.name}]?`)) {
      api.delete(project.id, true).then(onRemoved);
    }
  },
  async leave(project, onProjectLeft) {
    const res = await popup.addConfirm(`Вы действительно хотите покинуть проект [${project.name}]?`);
    if (!res) return;

    const { user } = store.state.auth;
    const member = project.projectMembers.find(m => m.user.id === user.id);

    if (!member) return; // todo maybe throw err

    await pmApi.delete(member.id, true)
      .then(() => {
        router.push({ name: 'project-list' });
        onProjectLeft();
      });
  },
};
